import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import QRCode from 'qrcode.react'

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from "../COMPONENTS/Loader";
import { openCommentModal, openMarketingModal } from "./../../REDUX/functions";

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class PrintQr extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            barcode: this.get('bc'),
            start: this.get('start'),
            end: this.get('end'),
            value: 'GD barcode:' + this.get('bc') + ';date:' + this.beautifyDate(this.get('start')) + ';valid_till:' + this.beautifyDate(this.get('end')) + ';'
        }
    }

    componentDidMount() {
        this.props.disableElements(false);
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    beautifyDate = (date) => {
        let parts = date.split('T');
        parts[0] = parts[0].split('-').reverse().join('.');

        return parts[0] + ' ' + parts[1] + ':00'
    }

    get(name) {
        if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(window.location.search))
            return decodeURIComponent(name[1]);
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        return (
            <div>
                <Helmet>
                    <title>Печать QR</title>
                </Helmet>
                <div>
                    <QRCode
                        id="qrCodeEl"
                        size={ 200 }
                        value={ this.state.value } />
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(PrintQr))
